<template>
   <dashboard-layout>
      <v-container fluid class="down-top-padding py-0">
         <BaseBreadcrumb
            :title="page.title"
            :icon="page.icon"
            :breadcrumbs="breadcrumbs"
         ></BaseBreadcrumb>
         <v-row>
            <v-col cols="12">
               <v-tabs
                  v-model="tab"
                  fixed-tabs
                  background-color="indigo"
                  dark
               >
                  <v-tab key="T1">
                     Annual Reports
                  </v-tab>
                  <v-tab key="T2">
                     Resolutions
                  </v-tab>
                  <v-tab key="T3">
                     Elections
                  </v-tab>
                  <v-tab key="T4">
                     e-Voting
                  </v-tab>
               </v-tabs>

               <v-tabs-items v-model="tab">
                  <v-tab-item key="T1">
                     <div class="pa-5 blue lighten-5">
                        <v-row>
                           <v-col cols="4">
                              <v-card rounded color="grey darken-1">
                                 <v-card-title class="text-white">Annual Report for 2020</v-card-title>
                                 <v-card-text>
                                    <span class="text-white">The quick brown fox jumps over the fence. The quick brown fox jumps over the fence. The quick brown fox jumps over the fence.</span>
                                 </v-card-text>
                                 <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn fab color="blue darken-1" small>
                                       <v-icon color="white">mdi-card-search</v-icon>
                                    </v-btn>
                                    <v-btn fab color="blue darken-1" small>
                                       <v-icon color="white">mdi-download</v-icon>
                                    </v-btn>
                                 </v-card-actions>
                              </v-card>
                           </v-col>
                           <v-col cols="4">
                              <v-card rounded color="grey darken-1">
                                 <v-card-title class="text-white">Annual Report for 2020</v-card-title>
                                 <v-card-text>
                                    <span class="text-white">The quick brown fox jumps over the fence. The quick brown fox jumps over the fence. The quick brown fox jumps over the fence.</span>
                                 </v-card-text>
                                 <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn fab color="blue darken-1" small>
                                       <v-icon color="white">mdi-card-search</v-icon>
                                    </v-btn>
                                    <v-btn fab color="blue darken-1" small>
                                       <v-icon color="white">mdi-download</v-icon>
                                    </v-btn>
                                 </v-card-actions>
                              </v-card>
                           </v-col>
                           <v-col cols="4">
                              <v-card rounded color="grey darken-1">
                                 <v-card-title class="text-white">Annual Report for 2020</v-card-title>
                                 <v-card-text>
                                    <span class="text-white">The quick brown fox jumps over the fence. The quick brown fox jumps over the fence. The quick brown fox jumps over the fence.</span>
                                 </v-card-text>
                                 <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn fab color="blue darken-1" small>
                                       <v-icon color="white">mdi-card-search</v-icon>
                                    </v-btn>
                                    <v-btn fab color="blue darken-1" small>
                                       <v-icon color="white">mdi-download</v-icon>
                                    </v-btn>
                                 </v-card-actions>
                              </v-card>
                           </v-col>
                           <v-col cols="4">
                              <v-card rounded color="grey darken-1">
                                 <v-card-title class="text-white">Annual Report for 2020</v-card-title>
                                 <v-card-text>
                                    <span class="text-white">The quick brown fox jumps over the fence. The quick brown fox jumps over the fence. The quick brown fox jumps over the fence.</span>
                                 </v-card-text>
                                 <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn fab color="blue darken-1" small>
                                       <v-icon color="white">mdi-card-search</v-icon>
                                    </v-btn>
                                    <v-btn fab color="blue darken-1" small>
                                       <v-icon color="white">mdi-download</v-icon>
                                    </v-btn>
                                 </v-card-actions>
                              </v-card>
                           </v-col>
                           <v-col cols="4">
                              <v-card rounded color="grey darken-1">
                                 <v-card-title class="text-white">Annual Report for 2020</v-card-title>
                                 <v-card-text>
                                    <span class="text-white">The quick brown fox jumps over the fence. The quick brown fox jumps over the fence. The quick brown fox jumps over the fence.</span>
                                 </v-card-text>
                                 <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn fab color="blue darken-1" small>
                                       <v-icon color="white">mdi-card-search</v-icon>
                                    </v-btn>
                                    <v-btn fab color="blue darken-1" small>
                                       <v-icon color="white">mdi-download</v-icon>
                                    </v-btn>
                                 </v-card-actions>
                              </v-card>
                           </v-col>
                           <v-col cols="4">
                              <v-card rounded color="grey darken-1">
                                 <v-card-title class="text-white">Annual Report for 2020</v-card-title>
                                 <v-card-text>
                                    <span class="text-white">The quick brown fox jumps over the fence. The quick brown fox jumps over the fence. The quick brown fox jumps over the fence.</span>
                                 </v-card-text>
                                 <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn fab color="blue darken-1" small>
                                       <v-icon color="white">mdi-card-search</v-icon>
                                    </v-btn>
                                    <v-btn fab color="blue darken-1" small>
                                       <v-icon color="white">mdi-download</v-icon>
                                    </v-btn>
                                 </v-card-actions>
                              </v-card>
                           </v-col>
                           <v-col cols="4">
                              <v-card rounded color="grey darken-1">
                                 <v-card-title class="text-white">Annual Report for 2020</v-card-title>
                                 <v-card-text>
                                    <span class="text-white">The quick brown fox jumps over the fence. The quick brown fox jumps over the fence. The quick brown fox jumps over the fence.</span>
                                 </v-card-text>
                                 <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn fab color="blue darken-1" small>
                                       <v-icon color="white">mdi-card-search</v-icon>
                                    </v-btn>
                                    <v-btn fab color="blue darken-1" small>
                                       <v-icon color="white">mdi-download</v-icon>
                                    </v-btn>
                                 </v-card-actions>
                              </v-card>
                           </v-col>
                        </v-row>
                        <br>
                     </div>
                     <!-- </v-container> -->
                     <!-- <v-card color="blue lighten-5" flat>
                        <v-card-text>
                           <v-row>
                              <v-col cols="3">

                              </v-col>
                           </v-row>
                        </v-card-text>
                     </v-card> -->
                  </v-tab-item>
                  <v-tab-item key="T2">
                     <div class="pa-5 blue lighten-5">
                        <v-row>
                           <v-col cols="4">
                              <v-card rounded color="grey darken-1">
                                 <v-card-title class="text-white">Resolution Document Title</v-card-title>
                                 <v-card-text>
                                    <span class="text-white">Resolution document summary. The quick brown fox jumps over the fence. The quick brown fox jumps over the fence. The quick brown fox jumps over the fence. </span>
                                 </v-card-text>
                                 <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn fab color="blue darken-1" small>
                                       <v-icon color="white">mdi-card-search</v-icon>
                                    </v-btn>
                                    <v-btn fab color="blue darken-1" small>
                                       <v-icon color="white">mdi-download</v-icon>
                                    </v-btn>
                                 </v-card-actions>
                              </v-card>
                           </v-col>
                           <v-col cols="4">
                              <v-card rounded color="grey darken-1">
                                 <v-card-title class="text-white">Resolution Document Title</v-card-title>
                                 <v-card-text>
                                    <span class="text-white">Resolution document summary. The quick brown fox jumps over the fence. The quick brown fox jumps over the fence. The quick brown fox jumps over the fence. </span>
                                 </v-card-text>
                                 <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn fab color="blue darken-1" small>
                                       <v-icon color="white">mdi-card-search</v-icon>
                                    </v-btn>
                                    <v-btn fab color="blue darken-1" small>
                                       <v-icon color="white">mdi-download</v-icon>
                                    </v-btn>
                                 </v-card-actions>
                              </v-card>
                           </v-col>
                           <v-col cols="4">
                              <v-card rounded color="grey darken-1">
                                 <v-card-title class="text-white">Resolution Document Title</v-card-title>
                                 <v-card-text>
                                    <span class="text-white">Resolution document summary. The quick brown fox jumps over the fence. The quick brown fox jumps over the fence. The quick brown fox jumps over the fence. </span>
                                 </v-card-text>
                                 <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn fab color="blue darken-1" small>
                                       <v-icon color="white">mdi-card-search</v-icon>
                                    </v-btn>
                                    <v-btn fab color="blue darken-1" small>
                                       <v-icon color="white">mdi-download</v-icon>
                                    </v-btn>
                                 </v-card-actions>
                              </v-card>
                           </v-col>
                           <v-col cols="4">
                              <v-card rounded color="grey darken-1">
                                 <v-card-title class="text-white">Resolution Document Title</v-card-title>
                                 <v-card-text>
                                    <span class="text-white">Resolution document summary. The quick brown fox jumps over the fence. The quick brown fox jumps over the fence. The quick brown fox jumps over the fence. </span>
                                 </v-card-text>
                                 <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn fab color="blue darken-1" small>
                                       <v-icon color="white">mdi-card-search</v-icon>
                                    </v-btn>
                                    <v-btn fab color="blue darken-1" small>
                                       <v-icon color="white">mdi-download</v-icon>
                                    </v-btn>
                                 </v-card-actions>
                              </v-card>
                           </v-col>
                           <v-col cols="4">
                              <v-card rounded color="grey darken-1">
                                 <v-card-title class="text-white">Resolution Document Title</v-card-title>
                                 <v-card-text>
                                    <span class="text-white">Resolution document summary. The quick brown fox jumps over the fence. The quick brown fox jumps over the fence. The quick brown fox jumps over the fence. </span>
                                 </v-card-text>
                                 <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn fab color="blue darken-1" small>
                                       <v-icon color="white">mdi-card-search</v-icon>
                                    </v-btn>
                                    <v-btn fab color="blue darken-1" small>
                                       <v-icon color="white">mdi-download</v-icon>
                                    </v-btn>
                                 </v-card-actions>
                              </v-card>
                           </v-col>
                           <v-col cols="4">
                              <v-card rounded color="grey darken-1">
                                 <v-card-title class="text-white">Resolution Document Title</v-card-title>
                                 <v-card-text>
                                    <span class="text-white">Resolution document summary. The quick brown fox jumps over the fence. The quick brown fox jumps over the fence. The quick brown fox jumps over the fence. </span>
                                 </v-card-text>
                                 <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn fab color="blue darken-1" small>
                                       <v-icon color="white">mdi-card-search</v-icon>
                                    </v-btn>
                                    <v-btn fab color="blue darken-1" small>
                                       <v-icon color="white">mdi-download</v-icon>
                                    </v-btn>
                                 </v-card-actions>
                              </v-card>
                           </v-col>
                           <v-col cols="4">
                              <v-card rounded color="grey darken-1">
                                 <v-card-title class="text-white">Resolution Document Title</v-card-title>
                                 <v-card-text>
                                    <span class="text-white">Resolution document summary. The quick brown fox jumps over the fence. The quick brown fox jumps over the fence. The quick brown fox jumps over the fence. </span>
                                 </v-card-text>
                                 <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn fab color="blue darken-1" small>
                                       <v-icon color="white">mdi-card-search</v-icon>
                                    </v-btn>
                                    <v-btn fab color="blue darken-1" small>
                                       <v-icon color="white">mdi-download</v-icon>
                                    </v-btn>
                                 </v-card-actions>
                              </v-card>
                           </v-col>
                           <v-col cols="4">
                              <v-card rounded color="grey darken-1">
                                 <v-card-title class="text-white">Resolution Document Title</v-card-title>
                                 <v-card-text>
                                    <span class="text-white">Resolution document summary. The quick brown fox jumps over the fence. The quick brown fox jumps over the fence. The quick brown fox jumps over the fence. </span>
                                 </v-card-text>
                                 <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn fab color="blue darken-1" small>
                                       <v-icon color="white">mdi-card-search</v-icon>
                                    </v-btn>
                                    <v-btn fab color="blue darken-1" small>
                                       <v-icon color="white">mdi-download</v-icon>
                                    </v-btn>
                                 </v-card-actions>
                              </v-card>
                           </v-col>
                        </v-row>
                     </div>
                  </v-tab-item>
                  <v-tab-item key="T3">
                     <div class="pa-5 blue lighten-5">
                        <v-row>
                           <v-col cols="12">
                              <v-list-item-title>
                                 Upcoming Elections
                              </v-list-item-title>
                           </v-col>
                           <v-col cols="12">
                              <v-card color="yellow lighten-4" rounded>
                                 <v-card-title>MIP National Council</v-card-title>
                                 <v-card-text>
                                    Intro text for the upcoming election. The quick brown fox jumps over the fence. The quick brown fox jumps over the fence.
                                    The quick brown fox jumps over the fence. The quick brown fox jumps over the fence. The quick brown fox jumps over the fence.
                                    The quick brown fox jumps over the fence. The quick brown fox jumps over the fence.
                                 </v-card-text>
                                 <v-card-subtitle><b>Date</b></v-card-subtitle>
                                 <v-card-text>
                                    Voters Registration Start: Wednesday, 2nd January 2021<br>
                                    Voters Registration End: Friday, 8th January 2021<br>
                                    Voting Start: Monday, 11th January 2021, 2:30 PM<br>
                                    Voting End: Friday, 15th January 2021, 4:30 PM
                                 </v-card-text>
                                 <v-card-subtitle><b>Rules</b></v-card-subtitle>
                                 <v-card-text>
                                    The quick brown fox jumps over the fence. The quick brown fox jumps over the fence. The quick brown fox jumps over the fence.
                                    The quick brown fox jumps over the fence. The quick brown fox jumps over the fence. The quick brown fox jumps over the fence.
                                    The quick brown fox jumps over the fence. The quick brown fox jumps over the fence. The quick brown fox jumps over the fence.
                                 </v-card-text>
                                 <!-- <v-card-subtitle><b>Candidates</b></v-card-subtitle>
                                 <v-card-text>
                                    <v-row>
                                       <v-col>
                                          <v-tooltip top>
                                             <template v-slot:activator="{ on, attrs }">
                                                <v-avatar color="indigo" height="150" width="140" v-bind="attrs" v-on="on">
                                                   <v-img src="/images/1.jpg" alt="Tony Otwell"/>
                                                </v-avatar>
                                             </template>
                                             <span>Tony Otwell</span>
                                          </v-tooltip>
                                          <v-tooltip top>
                                             <template v-slot:activator="{ on, attrs }">
                                                <v-avatar color="indigo" height="150" width="140" v-bind="attrs" v-on="on">
                                                   <v-img src="/images/2.jpg" alt="Mark Rogers"/>
                                                </v-avatar>
                                             </template>
                                             <span>Mark Rogers</span>
                                          </v-tooltip>
                                          <v-tooltip top>
                                             <template v-slot:activator="{ on, attrs }">
                                                <v-avatar color="indigo" height="150" width="140" v-bind="attrs" v-on="on">
                                                   <v-img src="/images/6.jpg" alt="Angelina Tay"/>
                                                </v-avatar>
                                             </template>
                                             <span>Angelina Tay</span>
                                          </v-tooltip>
                                          <v-tooltip top>
                                             <template v-slot:activator="{ on, attrs }">
                                                <v-avatar color="indigo" height="150" width="140" v-bind="attrs" v-on="on">
                                                   <v-img src="/images/4.jpg" alt="Gillian Rosemary"/>
                                                </v-avatar>
                                             </template>
                                             <span>Gillian Rosemary</span>
                                          </v-tooltip>
                                       </v-col>
                                    </v-row>
                                 </v-card-text> -->
                                 <v-divider></v-divider>
                                 <v-card-subtitle><b>Voters</b></v-card-subtitle>
                                 <v-card-text>
                                    Total Registered Voters (Up till today): <h3><span style="color: green">150</span></h3>
                                 </v-card-text>
                                 <v-card-actions class="pb-5">
                                    <v-spacer></v-spacer>
                                    <v-tooltip top>
                                       <template v-slot:activator="{ on, attrs }">
                                          <v-btn fab small color="primary" v-bind="attrs" v-on="on">
                                             <v-icon color="white">mdi-pencil-plus</v-icon>
                                          </v-btn>
                                       </template>
                                       <span>Register as Voter</span>
                                    </v-tooltip>
                                    <v-spacer></v-spacer>
                                 </v-card-actions>
                              </v-card>
                           </v-col>
                        </v-row>
                     </div>
                  </v-tab-item>
                  <v-tab-item key="T4">
                     <div class="pa-5 blue lighten-5">
                        <v-row>
                           <v-col cols="12">
                              <v-list-item-title>
                                 E-Voting: Active Elections
                              </v-list-item-title>
                           </v-col>
                           <v-col cols="12">
                              <v-row dense>
                                 <v-col cols="4">
                                    <v-card>
                                       <v-card-title>MIP National Council</v-card-title>
                                       <v-card-text>
                                          Voting Start:<br> Monday, 11th January 2021, 2:30 PM<br>
                                          <br>Voting End:<br> Friday, 15th January 2021, 4:30 PM<br>
                                          <br>Total Registered Voters:<br> 150
                                       </v-card-text>
                                    </v-card>
                                 </v-col>
                                 <v-col cols="8">
                                    <v-card>
                                       <v-card-title>Candidates for: Chair Person</v-card-title>
                                       <v-card-text>
                                          <v-row dense class="pb-6">
                                             <v-col class="d-flex justify-center">
                                                <v-tooltip top>
                                                   <template v-slot:activator="{ on, attrs }">
                                                      <v-avatar color="indigo" height="150" width="140" v-bind="attrs" v-on="on">
                                                         <v-img src="/images/1.jpg" alt="Tony Otwell"/>
                                                      </v-avatar>
                                                   </template>
                                                   <span>Tony Otwell</span>
                                                </v-tooltip>
                                                <v-tooltip top>
                                                   <template v-slot:activator="{ on, attrs }">
                                                      <v-btn fab color="primary" small absolute bottom v-bind="attrs" v-on="on" @click="CastVote(1)">
                                                         <v-icon>mdi-pencil</v-icon>
                                                      </v-btn>
                                                   </template>
                                                   <span>Cast My Vote</span>
                                                </v-tooltip>
                                             </v-col>
                                             <v-col class="d-flex justify-center">
                                                <v-tooltip top>
                                                   <template v-slot:activator="{ on, attrs }">
                                                      <v-avatar color="indigo" height="150" width="140" v-bind="attrs" v-on="on">
                                                         <v-img src="/images/2.jpg" alt="Mark Rogers"/>
                                                      </v-avatar>
                                                   </template>
                                                   <span>Mark Rogers</span>
                                                </v-tooltip>
                                                <v-tooltip top>
                                                   <template v-slot:activator="{ on, attrs }">
                                                      <v-btn fab color="primary" small absolute bottom v-bind="attrs" v-on="on" @click="CastVote(2)">
                                                         <v-icon>mdi-pencil</v-icon>
                                                      </v-btn>
                                                   </template>
                                                   <span>Cast My Vote</span>
                                                </v-tooltip>
                                             </v-col>
                                             <v-col class="d-flex justify-center">
                                                <v-tooltip top>
                                                   <template v-slot:activator="{ on, attrs }">
                                                      <!-- <div> -->
                                                         <v-avatar color="indigo" height="150" width="140" v-bind="attrs" v-on="on">
                                                            <v-img src="/images/6.jpg" alt="Angelina Tay"/>
                                                         </v-avatar>
                                                      <!-- </div> -->
                                                   </template>
                                                   <span>Angelina Tay</span>
                                                </v-tooltip>
                                                <v-tooltip top>
                                                   <template v-slot:activator="{ on, attrs }">
                                                      <v-btn fab color="primary" small absolute bottom v-bind="attrs" v-on="on" @click="CastVote(6)">
                                                         <v-icon>mdi-pencil</v-icon>
                                                      </v-btn>
                                                   </template>
                                                   <span>Cast My Vote</span>
                                                </v-tooltip>
                                             </v-col>
                                             <v-col class="d-flex justify-center">
                                                <v-tooltip top>
                                                   <template v-slot:activator="{ on, attrs }">
                                                      <v-avatar color="indigo" height="150" width="140" v-bind="attrs" v-on="on">
                                                         <v-img src="/images/4.jpg" alt="Gillian Rosemary"/>
                                                      </v-avatar>
                                                   </template>
                                                   <span>Gillian Rosemary</span>
                                                </v-tooltip>
                                                <v-tooltip top>
                                                   <template v-slot:activator="{ on, attrs }">
                                                      <v-btn fab color="primary" small absolute bottom v-bind="attrs" v-on="on" @click="CastVote(4)">
                                                         <v-icon>mdi-pencil</v-icon>
                                                      </v-btn>
                                                   </template>
                                                   <span>Cast My Vote</span>
                                                </v-tooltip>
                                             </v-col>
                                          </v-row>
                                       </v-card-text>
                                    </v-card>
                                    <v-card>
                                       <v-card-title>Candidates for: Executives</v-card-title>
                                       <v-card-text>
                                          <v-row dense class="pb-6">
                                             <v-col class="d-flex justify-center">
                                                <v-tooltip top>
                                                   <template v-slot:activator="{ on, attrs }">
                                                      <v-avatar color="indigo" height="150" width="140" v-bind="attrs" v-on="on">
                                                         <v-img src="/images/1.jpg" alt="Tony Otwell"/>
                                                      </v-avatar>
                                                   </template>
                                                   <span>Tony Otwell</span>
                                                </v-tooltip>
                                                <v-tooltip top>
                                                   <template v-slot:activator="{ on, attrs }">
                                                      <v-btn fab color="primary" small absolute bottom v-bind="attrs" v-on="on" @click="CastVote(1)">
                                                         <v-icon>mdi-pencil</v-icon>
                                                      </v-btn>
                                                   </template>
                                                   <span>Cast My Vote</span>
                                                </v-tooltip>
                                             </v-col>
                                             <v-col class="d-flex justify-center">
                                                <v-tooltip top>
                                                   <template v-slot:activator="{ on, attrs }">
                                                      <v-avatar color="indigo" height="150" width="140" v-bind="attrs" v-on="on">
                                                         <v-img src="/images/2.jpg" alt="Mark Rogers"/>
                                                      </v-avatar>
                                                   </template>
                                                   <span>Mark Rogers</span>
                                                </v-tooltip>
                                                <v-tooltip top>
                                                   <template v-slot:activator="{ on, attrs }">
                                                      <v-btn fab color="primary" small absolute bottom v-bind="attrs" v-on="on" @click="CastVote(2)">
                                                         <v-icon>mdi-pencil</v-icon>
                                                      </v-btn>
                                                   </template>
                                                   <span>Cast My Vote</span>
                                                </v-tooltip>
                                             </v-col>
                                             <v-col class="d-flex justify-center">
                                                <v-tooltip top>
                                                   <template v-slot:activator="{ on, attrs }">
                                                      <!-- <div> -->
                                                         <v-avatar color="indigo" height="150" width="140" v-bind="attrs" v-on="on">
                                                            <v-img src="/images/6.jpg" alt="Angelina Tay"/>
                                                         </v-avatar>
                                                      <!-- </div> -->
                                                   </template>
                                                   <span>Angelina Tay</span>
                                                </v-tooltip>
                                                <v-tooltip top>
                                                   <template v-slot:activator="{ on, attrs }">
                                                      <v-btn fab color="primary" small absolute bottom v-bind="attrs" v-on="on" @click="CastVote(6)">
                                                         <v-icon>mdi-pencil</v-icon>
                                                      </v-btn>
                                                   </template>
                                                   <span>Cast My Vote</span>
                                                </v-tooltip>
                                             </v-col>
                                             <v-col class="d-flex justify-center">
                                                <v-tooltip top>
                                                   <template v-slot:activator="{ on, attrs }">
                                                      <v-avatar color="indigo" height="150" width="140" v-bind="attrs" v-on="on">
                                                         <v-img src="/images/4.jpg" alt="Gillian Rosemary"/>
                                                      </v-avatar>
                                                   </template>
                                                   <span>Gillian Rosemary</span>
                                                </v-tooltip>
                                                <v-tooltip top>
                                                   <template v-slot:activator="{ on, attrs }">
                                                      <v-btn fab color="primary" small absolute bottom v-bind="attrs" v-on="on" @click="CastVote(4)">
                                                         <v-icon>mdi-pencil</v-icon>
                                                      </v-btn>
                                                   </template>
                                                   <span>Cast My Vote</span>
                                                </v-tooltip>
                                             </v-col>
                                          </v-row>
                                       </v-card-text>
                                    </v-card>
                                 </v-col>
                              </v-row>
                           </v-col>
                        </v-row>
                     </div>
                  </v-tab-item>
               </v-tabs-items>
            </v-col>
         </v-row>
         <v-dialog v-model="dlgvote" persistent max-width="600">
            <v-card color="grey lighten-2">
               <v-card-title>Cast your vote for this candidate?</v-card-title>
               <v-divider></v-divider>
               <v-img :src="'/images/' + selectedcandidate + '.jpg'"></v-img>
               <v-card-text style="height: 300px;">
                  <div class="pa-3">
                     <h3 class="pb-3">{{ selectedname }}</h3>
                     <p>
                        Description about the candidate. The quick brown fox jumps over the fence. The quick brown fox jumps over the fence.
                        The quick brown fox jumps over the fence. The quick brown fox jumps over the fence. The quick brown fox jumps over
                        the fence. The quick brown fox jumps over the fence. The quick brown fox jumps over the fence. The quick brown fox
                        jumps over the fence.
                     </p>
                     <h4 class="pb-3">Campaign Materials</h4>
                     <ul>
                        <li><a href="#">Manifest</a></li>
                        <li><a href="#">Pledge</a></li>
                     </ul>
                  </div>
               </v-card-text>
               <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" @click="dlgvote = false" dark>
                     Yes
                  </v-btn>
                  <v-btn color="blue darken-1" @click="dlgvote = false" dark>
                     No
                  </v-btn>
                  <v-spacer></v-spacer>
               </v-card-actions>
            </v-card>
         </v-dialog>
      </v-container>
   </dashboard-layout>
</template>

<script>
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import DashboardLayout from '@/Layouts/DashboardLayout.vue'

export default {
   name: "MOMMIPAGM",

   props: ['user'],

   data() {
      return {
         dlgvote: false,
         tab: null,
         page: {
         title: "MIP AGM",
         },
         breadcrumbs: [
            {
               text: "Dashboard",
               disabled: false,
               to: "/dashboard",
            },
            {
               text: "MIP AGM",
               disabled: true,
            },
         ],
         selectedcandidate: 1,
         selectedname: "",
      }
   },

   components: {
      DashboardLayout,
      BaseBreadcrumb,
   },

   methods: {
      CastVote(pCandidate) {
         this.selectedcandidate = pCandidate
         if (this.selectedcandidate === 1) this.selectedname = "Tony Otwell"
         if (this.selectedcandidate === 2) this.selectedname = "Mark Rogers"
         if (this.selectedcandidate === 6) this.selectedname = "Angelina Tay"
         if (this.selectedcandidate === 4) this.selectedname = "Gillian Rosemary"
         this.dlgvote = true
      }
   },

   computed: {

   }


};
</script>

<style>
</style>
